import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-34a3be86")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "page-break" }, null, -1)
const _hoisted_2 = { class: "init-info" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "跟团号/微信昵称"),
    /*#__PURE__*/_createElementVNode("th", null, "联系人/电话/备注"),
    /*#__PURE__*/_createElementVNode("th", null, "商品规格"),
    /*#__PURE__*/_createElementVNode("th", null, "数量")
  ])
], -1)
_popScopeId()

import { ref, onMounted } from "vue"

export default /*#__PURE__*/_defineComponent({
  props: {
	initData: Array
},
  setup(__props) {

const props = __props

const pdfItem = ref<any>([])
const renderPage = (data: any) => {
	const categorizedObjects = Object.values(categorizeOrdersByPickupPoint(data))
	pdfItem.value = categorizedObjects.map((item: any) => {
		let obj = {
			troupe: item[0]['团长'],
			troupeName: item[0]['自提点联系人'],
			troupePhone: item[0]['自提点电话'],
			location: item[0]['自提点'],
			address: item[0]['自提点地址'],
			orderNum: 0,
			productNum: 0,
			list: [] as any
		}
		obj.list = item.map((value: any) => {
			obj.orderNum = obj.orderNum + 1
			obj.productNum = obj.productNum + Number(value['数量'])
			return {
				troupeNum: value['跟团号'],
				WXname: value['下单人'],
				name: value['收货人'],
				phone: value['联系电话'],
				type: value['商品'],
				num: value['数量'],
			}
		})
		return obj
	});
}

function categorizeOrdersByPickupPoint(ordersArray: any) {
	const categorizedOrders: any = {};
	for (const order of ordersArray) {
		const pickupPoint = order["自提点"];
		if (!categorizedOrders[pickupPoint]) {
			categorizedOrders[pickupPoint] = [];
		}
		categorizedOrders[pickupPoint].push(order);
	}
	return categorizedOrders;
}
onMounted(() => {
	renderPage(props.initData)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pdfItem.value, (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "pdf-item",
      key: index
    }, [
      _hoisted_1,
      _createElementVNode("h2", null, _toDisplayString(item.location), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, "自提点联系人：" + _toDisplayString(item.troupeName) + "(" + _toDisplayString(item.troupePhone) + ")", 1),
          _createElementVNode("div", null, "自提点地址：" + _toDisplayString(item.address), 1),
          _createElementVNode("div", null, "团长信息：" + _toDisplayString(item.troupe), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, "订单数：" + _toDisplayString(item.orderNum), 1),
          _createElementVNode("div", null, "商品件数：" + _toDisplayString(item.productNum), 1)
        ])
      ]),
      _createElementVNode("table", null, [
        _hoisted_5,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (value, idx) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: value.phone
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("div", null, _toDisplayString(value.troupeNum), 1),
                _createElementVNode("div", null, _toDisplayString(value.WXname), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", null, _toDisplayString(value.name), 1),
                _createElementVNode("div", null, _toDisplayString(value.phone), 1)
              ]),
              _createElementVNode("td", null, _toDisplayString(value.type), 1),
              _createElementVNode("td", null, _toDisplayString(value.num), 1)
            ]))
          }), 128))
        ])
      ])
    ]))
  }), 128))
}
}

})